import { useMutation, useQueryClient } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { createEnablementInfo } from 'services';
import { useSnackbar } from 'hooks';
import { EnablementInfoPayloadV3 } from 'interface/WizardV3';
import { ENABLEMENT_INFO_KEY, CAMPAIGN_STATUS_KEY } from '../constants';

export function useCreateEnablementInfo() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const queryClient = useQueryClient();

  const errorMessage = 'Something went wrong, please try again later.';
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: (payload: EnablementInfoPayloadV3) =>
      createEnablementInfo(corpAcctNbr, payload),
    onSuccess: (data) => {
      queryClient.setQueryData([ENABLEMENT_INFO_KEY], data);
      // Invalidate the CAMPAIGN_STATUS_KEY to refetch the data and cause
      // all subsequent save/submit actions to PATCH instead of POST
      void queryClient.invalidateQueries([CAMPAIGN_STATUS_KEY]);
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
